import type { base } from "./themes/base";

// A pseudo-outline
export const toShadowRing = (
  weight: "thin" | "thick",
  colorToken: keyof (typeof base)["colors"],
): string => `0 0 0 ${weight === "thin" ? 1 : 2}px $colors$${colorToken}`;
